import { render, staticRenderFns } from "./PanelVariable.vue?vue&type=template&id=08213534&"
import script from "./PanelVariable.vue?vue&type=script&lang=js&"
export * from "./PanelVariable.vue?vue&type=script&lang=js&"
import style0 from "./PanelVariable.vue?vue&type=style&index=0&id=08213534&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08213534')) {
      api.createRecord('08213534', component.options)
    } else {
      api.reload('08213534', component.options)
    }
    module.hot.accept("./PanelVariable.vue?vue&type=template&id=08213534&", function () {
      api.rerender('08213534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/PanelVariable.vue"
export default component.exports